module.exports = __webpack_public_path__ + "img/study-room.ff860d1f.jpg";